export default __webpack_public_path__ + "static/media/hero 555.f355fa05.jpg";